import React, { useEffect } from 'react';

const PaymentMethodOptions = [
    { value: 'cheque', label: 'چک' },
    { value: 'barter', label: 'تهاتر' },
    { value: 'cash', label: 'وجه نقد' },
    { value: 'pos', label: 'پوز' },
    { value: 'online_payment', label: 'درگاه پرداخت اینترنتی' },
    { value: 'card_to_card', label: 'کارت به کارت' },
    { value: 'transfer', label: 'انتقال به حساب' },
    { value: 'other', label: 'سایر' },
];

function PaymentInfoStep({ formData, onDataChange, calculatedTotals, readOnly, mode, isShow = () => true, isRequired = () => false, ...rest }) {

    // هر بار که مجموع صورتحساب تغییر کرد مبلغ پرداختی رو آپدیت کن
    useEffect(() => {
        if (readOnly || !calculatedTotals?.sumTotalPrice) return;
        const total = calculatedTotals.sumTotalPrice || 0;
        const taxPrice = calculatedTotals.sumTaxPrice || 0;
        const otherTax = calculatedTotals.sumOtherTax || 0;
        const baseAmount = Math.trunc(total - otherTax - taxPrice);
        if (formData.paymentType === 'cash') {
            onDataChange({ cashPayment: baseAmount, creditPayment: 0 });
        } else if (formData.paymentType === 'credit') {
            onDataChange({ creditPayment: baseAmount, cashPayment: 0 });
        } else if (formData.paymentType === 'mixed') {
            // در حالت mixed دست کاربر رو نمی‌گیریم
        } else {
            onDataChange({ cashPayment: baseAmount });
        }
    }, [calculatedTotals?.sumTotalPrice, formData.paymentType, readOnly]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        let val = value;

        if (['cashPayment', 'creditPayment', 'vppSum', 'paymentPrice', 'trackingNum', 'num17', 'paymentSwitch', 'storeNum', 'terminalNum', 'buyerCardNum'].includes(name)) {
            val = value === '' ? '' : parseInt(value, 10);
        }

        if (formData.paymentType === 'mixed') {
            const total = Math.trunc(parseFloat(calculatedTotals?.sumTotalPrice) || 0);

            if (name === 'cashPayment') {
                const cash = parseInt(value || 0);
                const adjustedCash = Math.min(cash, total);
                const adjustedCredit = total - adjustedCash;
                onDataChange({
                    cashPayment: adjustedCash,
                    creditPayment: adjustedCredit
                });
                return;
            }

            if (name === 'creditPayment') {
                const credit = parseInt(value || 0);
                const adjustedCredit = Math.min(credit, total);
                const adjustedCash = total - adjustedCredit;
                onDataChange({
                    creditPayment: adjustedCredit,
                    cashPayment: adjustedCash
                });
                return;
            }
        }

        onDataChange({ [name]: val });
    };

    const isMixedPayment = formData.paymentType === 'mixed';

    return (
        <div className="step-content">
            <h5 className="mb-4">اطلاعات پرداخت</h5>
            <div className="row">
                {isShow('cashPayment') && (
                    <div className="col-lg-4 col-md-6 col-12 mb-3">
                        <label htmlFor="cashPayment" className="form-label">
                            مبلغ پرداختی نقدی {formData.paymentType !== 'credit' && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="number"
                            min="0"
                            step="any"
                            className="form-control"
                            id="cashPayment"
                            name="cashPayment"
                            value={formData.cashPayment === 0 ? '' : formData.cashPayment}
                            onChange={handleChange}
                            placeholder={calculatedTotals?.sumTotalPrice ? calculatedTotals.sumTotalPrice.toLocaleString('fa-IR').replace(/[^0-9\u06F0-\u06F9]/g, '') : "0"}
                            required={formData.paymentType !== 'credit'}
                            disabled={readOnly || (!isMixedPayment && formData.paymentType !== 'cash')}
                        />
                    </div>
                )}

                {isShow('creditPayment') && (
                    <div className="col-lg-4 col-md-6 col-12 mb-3">
                        <label htmlFor="creditPayment" className="form-label">
                            مبلغ نسیه {formData.paymentType !== 'cash' && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="number"
                            min="0"
                            step="any"
                            className="form-control"
                            id="creditPayment"
                            name="creditPayment"
                            value={formData.creditPayment || ''}
                            onChange={handleChange}
                            placeholder="0"
                            disabled={readOnly || (!isMixedPayment && formData.paymentType !== 'credit')}
                        />
                    </div>
                )}

                {isShow('paymentDate') && (
                    <div className="col-lg-4 col-md-6 col-12 mb-3">
                        <label htmlFor="paymentDate" className="form-label">
                            تاریخ و زمان پرداخت {isRequired('paymentDate') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="paymentDate"
                            name="paymentDate"
                            value={formData.paymentDate || ''}
                            onChange={handleChange}
                            placeholder="1402/01/01 12:00"
                            disabled={readOnly}
                        />
                    </div>
                )}

                {isShow('paymentPrice') && (
                    <div className="col-lg-4 col-md-6 col-12 mb-3">
                        <label htmlFor="paymentPrice" className="form-label">
                            مبلغ پرداختی {isRequired('paymentPrice') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="number"
                            min="0"
                            step="any"
                            className="form-control"
                            id="paymentPrice"
                            name="paymentPrice"
                            value={formData.paymentPrice || ''}
                            onChange={handleChange}
                            placeholder="0"
                            disabled={readOnly}
                        />
                    </div>
                )}

                {isShow('trackingNum') && (
                    <div className="col-lg-4 col-md-6 col-12 mb-3">
                        <label htmlFor="trackingNum" className="form-label">
                            شماره پیگیری/شماره مرجع {isRequired('trackingNum') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="number"
                            className="form-control"
                            id="trackingNum"
                            name="trackingNum"
                            value={formData.trackingNum || ''}
                            onChange={handleChange}
                            disabled={readOnly}
                        />
                    </div>
                )}

                {isShow('num17') && (
                    <div className="col-lg-4 col-md-6 col-12 mb-3">
                        <label htmlFor="num17" className="form-label">
                            مالیات موضوع ماده 17 {isRequired('num17') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="number"
                            min="0"
                            className="form-control"
                            id="num17"
                            name="num17"
                            value={formData.num17 || ''}
                            onChange={handleChange}
                            disabled={readOnly}
                        />
                    </div>
                )}

                {isShow('paymentSwitch') && (
                    <div className="col-lg-4 col-md-6 col-12 mb-3">
                        <label htmlFor="paymentSwitch" className="form-label">
                            شماره سوئیچ پرداخت {isRequired('paymentSwitch') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="number"
                            className="form-control"
                            id="paymentSwitch"
                            name="paymentSwitch"
                            value={formData.paymentSwitch || ''}
                            onChange={handleChange}
                            disabled={readOnly}
                        />
                    </div>
                )}

                {isShow('storeNum') && (
                    <div className="col-lg-4 col-md-6 col-12 mb-3">
                        <label htmlFor="storeNum" className="form-label">
                            شماره پذیرنده فروشگاهی {isRequired('storeNum') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="number"
                            className="form-control"
                            id="storeNum"
                            name="storeNum"
                            value={formData.storeNum || ''}
                            onChange={handleChange}
                            disabled={readOnly}
                        />
                    </div>
                )}

                {isShow('terminalNum') && (
                    <div className="col-lg-4 col-md-6 col-12 mb-3">
                        <label htmlFor="terminalNum" className="form-label">
                            شماره پایانه {isRequired('terminalNum') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="number"
                            className="form-control"
                            id="terminalNum"
                            name="terminalNum"
                            value={formData.terminalNum || ''}
                            onChange={handleChange}
                            disabled={readOnly}
                        />
                    </div>
                )}

                {isShow('paymentMethod') && (
                    <div className="col-lg-4 col-md-6 col-12 mb-3">
                        <label htmlFor="paymentMethod" className="form-label">
                            روش پرداخت {isRequired('paymentMethod') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <select
                            className="form-select"
                            id="paymentMethod"
                            name="paymentMethod"
                            value={formData.paymentMethod || ''}
                            onChange={handleChange}
                            disabled={readOnly}
                        >
                            <option value="">انتخاب کنید...</option>
                            {PaymentMethodOptions.map(opt => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                        </select>
                    </div>
                )}

                {isShow('buyerCardNum') && (
                    <div className="col-lg-4 col-md-6 col-12 mb-3">
                        <label htmlFor="buyerCardNum" className="form-label">
                            شماره کارت پرداخت کننده صورتحساب {isRequired('buyerCardNum') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="number"
                            className="form-control"
                            id="buyerCardNum"
                            name="buyerCardNum"
                            value={formData.buyerCardNum || ''}
                            onChange={handleChange}
                            disabled={readOnly}
                        />
                    </div>
                )}

                {isShow('vppSum') && (
                    <div className="col-lg-4 col-md-6 col-12 mb-3">
                        <label htmlFor="vppSum" className="form-label">
                            مجموع سهم مالیات بر ارزش افزوده از پرداخت {isRequired('vppSum') && !readOnly && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="number"
                            min="0"
                            step="any"
                            className="form-control"
                            id="vppSum"
                            name="vppSum"
                            value={formData.vppSum || ''}
                            onChange={handleChange}
                            placeholder="0"
                            disabled={readOnly}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

export default PaymentInfoStep;